export function toLocaleDateTime(date) {
  return new Date(date).toLocaleString("es-MX");
}

export function toTimeStamp(date) {
  return new Date(date).getTime();
}

export function getMinimalYearForFinancimiento() {
  const max = new Date().getFullYear();
  const min = 2019;
  return min;
}

export const getYears = () => {
  let years = [];
  const currentYear = new Date().getFullYear();
  for (let index = currentYear; index >= 1945; index--) {
    years.push({ id: index, value: index });
  }
  return years;
};
